export default __webpack_public_path__ + "306abe79b8ccacb46496a6e299725ff4.jpg";